import React from "react";
import { getLabel } from "../../data/labels";
import { formatDate } from '../utils/formatDate';
import { getConfiguration } from '../utils/configuration';
import { getCurrencyValue } from '../utils/getCurrencyValue';


function BetOptionsModalContent(props) {

    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
    
    const checkedValue = props.betOptionsData.checkedValue;
    const betOptionsData = props.betOptionsData.options;
    const selectorFunction = props.betOptionsData.selectorFunction;
    const type = props.betOptionsData.type;
    
    function selectRadio(value){
    	selectorFunction(value, type);
    	props.closeFunction();
    }
 
    return <div className="bonus-schedina_template-1">
    	<div className="bonus-schedina_template-1_body">
            <div className="bet-options-selectors-container">
			{
				type === 'freebet' && <>
					<div className="bonus-schedina_template-1_body_title">
                    	<p><span>{getLabel('carrello.freebet.title_part2')}</span></p>
                    </div>
	                {betOptionsData.map(function(betOption){
	                    const reactKey =  "bonus-" + betOption.id_bonus;
	                    return (
	                        <div key={"bet-option-" + betOption.id_bonus} className={"bonus-schedina_template-1_body_card" + (betOption.importo > 0? '':'d-none')}>
	                            <div className="bonus-schedina_template-1_body_card_title">
	                                <p>{betOption.sigla_promo} - {betOption.id_bonus}</p>
	                                <input checked={checkedValue.value == betOption.id_bonus + ""} 
	                                    onChange={() => {selectRadio(betOption.id_bonus + "", betOption.type)}} 
	                                    type="radio" 
	                                    className="pointer bonusWageringRadio" 
	                                    name={reactKey}
	                                    key={reactKey}
	                                    value={reactKey} />
	                            </div>
	                             <div>
	                                <p>{getLabel('carrello.freebet.total_amount')} <span className="grassetto">{getCurrencyValue(betOption.importo, mult, nDec, currency)} </span></p>
	                            </div>
	                            {
                            	betOption.data_fine_raccolta &&
                            	<div> <p>{getLabel('wagering.expire_date')}: {formatDate(betOption.data_fine_raccolta).formatted}</p></div> 
                            	}
	                        </div>
	                    )
	                })}
				
				</>
			
			}
			{
				type === 'funbonus' && <>
			     <div className="bonus-schedina_template-1_body_title">
                 	<p><span>{getLabel('carrello.fun_bonus.title_part2')}</span></p>
                 </div>      
                 {betOptionsData.map(function(betOption){
                    const perc = (betOption.importo_giocato * 100) / betOption.importo_da_giocare;
                    const reactKey = "bonus-" + betOption.id_bonus;
                    return (
                        <div key={"bet-option-" + betOption.id_bonus} className={"bonus-schedina_template-1_body_card" + (betOption.importo > 0? '':'d-none')}>
                            <div className="bonus-schedina_template-1_body_card_title">
                                <p>{betOption?.descrizione_promo ? betOption.descrizione_promo : betOption.sigla_promo}</p>
                                <input checked={checkedValue.value == betOption.id_bonus + ""} 
                                    onChange={() => {selectRadio(betOption.id_bonus + "", betOption.type)}} 
                                    type="radio" 
                                    className="pointer bonusWageringRadio" 
                                    name={reactKey}
                                    key={reactKey}
                                    value={reactKey} />
                            </div>
                            <div>
                                <p className="funbonus__items--wrapper"><span className="funbonus__items--desc">{getLabel('carrello.fun_bonus.remaining_balance')}</span> <span className="funbonus__items--value">{getCurrencyValue(betOption.importo, mult, nDec, currency)}</span></p>
                            </div>
                            {
                            	betOption.data_fine_raccolta &&
                            	<div> <p className="funbonus__items--wrapper"><span className="funbonus__items--desc">{getLabel('wagering.expire_date')}:</span> <span className="funbonus__items--value">{formatDate(betOption.data_fine_raccolta).formatted}</span></p></div> 
                            }
                            {
	                        	betOption.rollover &&
	                        	<div> <p className="funbonus__items--wrapper"><span className="funbonus__items--desc">{getLabel('wagering.rollover')}:</span> <span className="funbonus__items--value">{betOption.rollover}</span></p></div> 
                            }                          
                            <div className="bonus-schedina_template-1_body_card_progress progress">
                                <div className="progress-bar" role="progressbar" style={{ width: perc + '%'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                </div>
                                <p className="bonus-schedina_template-1_body_card_progress_text">
                                    {getCurrencyValue(betOption.importo_giocato, mult, nDec, currency)}
                                    / 
                                    {getCurrencyValue(betOption.importo_da_giocare, mult, nDec, currency)} 
                                </p>
                            </div>
                            <div className="bonus-schedina_template-1_body_card_range">
                                <p className="funbonus__bonus--wrapper"><span className="funbonus__bonus--desc">{getLabel('carrello.fun_bonus.min')}</span> <span className="funbonus__bonus--value">{getCurrencyValue(betOption.min_bet, mult, nDec, currency)}</span> </p>
                                <p className="funbonus__bonus--wrapper"><span className="funbonus__bonus--desc">{getLabel('carrello.fun_bonus.max')}</span> <span className="funbonus__bonus--value">{getCurrencyValue(betOption.max_bet, mult, nDec, currency)}</span> </p>
    
                            </div>
                        </div>
                    )
                })}
                 
				</>
			}
        </div>
	</div>
 </div>
}

export default BetOptionsModalContent;